const AUTH_KEYS = ['token', 'username', 'email', 'admin-id'];

export const getAuthToken = () => sessionStorage.getItem('token') || localStorage.getItem('token');

export const setAuthSession = ({token, username, email, adminId}) => {
    if (token) {
        sessionStorage.setItem('token', token);
        localStorage.setItem('token', token);
    }

    if (username) {
        sessionStorage.setItem('username', username);
        localStorage.setItem('username', username);
    }

    if (email) {
        sessionStorage.setItem('email', email);
        localStorage.setItem('email', email);
    }

    if (adminId) {
        sessionStorage.setItem('admin-id', adminId);
        localStorage.setItem('admin-id', adminId);
    }
};

export const hydrateAuthSession = () => {
    AUTH_KEYS.forEach(key => {
        const sessionValue = sessionStorage.getItem(key);
        const localValue = localStorage.getItem(key);

        if (!sessionValue && localValue) {
            sessionStorage.setItem(key, localValue);
        }

        if (sessionValue && !localValue) {
            localStorage.setItem(key, sessionValue);
        }
    });

    return getAuthToken();
};

export const clearAuthSession = () => {
    AUTH_KEYS.forEach(key => {
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
    });
};
